import {Nav, Button, Col, Form, Modal, Row, Spinner} from "react-bootstrap";
import Cards from "react-credit-cards";
import React, {useCallback, useEffect, useState} from "react";
import {EMAIL_VALIDATE, formatCardNumber, formatCvc, formatExpiry, ONLY_NUMBER_REGEX} from "../../formatter";
import {
    adminManagementCheckUrl,
    connectionErrorMessage,
    errorMessage,
    getAddressByOwnerTenantIdUrl,
    getCityListUrl,
    getDistrictsByCityIdUrl,
    getPaymentInstallmentsUrl,
    payUrl,
    saveAddressUrl,
    testErrorPaymentUrl,
    testSuccessPaymentUrl
} from "../../data";
import {toast} from "react-toastify";
import SinglePaymentTable from "../SinglePaymentTable";
import InstallmentsTable from "../InstallmentsTable";
import {Link} from "@mui/material";
import TextField from "@mui/material/TextField";
import EditIcon from '@mui/icons-material/Edit';
import {debugLog} from "../../debug";
import PaymentTestSimulationPanel from "../PaymentTestSimulationPanel";

function PaymentModal(props) {

    const [cardState, setCardState] = useState({
        cvc: '',
        expiry: '',
        focus: '',
        name: '',
        number: '',
        email: '',
        gsm: ''
    });

    const [validState, setValidState] = useState({
        cvc: false,
        expiry: false,
        name: false,
        number: false,
        email: false,
        gsm: false
    });
    const [creditCardValidated, setCreditCardValidated] = useState(false);
    const [secureScreenShow, setSecureScreenShow] = useState(false);
    const [secureUrl, setSecureUrl] = useState('');
    const [paymentProcessing, setPaymentProcessing] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [hasAdminManagement, setHasAdminManagement] = React.useState(false);
    const [payPaymentId, setPayPaymentId] = React.useState('');
    const [testProcessing, setTestProcessing] = React.useState(false);
    const [showInstallments, setShowInstallments] = React.useState(false);
    const [installmentData, setInstallmentData] = React.useState([]);
    const [selectedInstallmentId, setSelectedInstallmentId] = React.useState("MO_01");
    const [cities, setCities] = useState([]);
    const [addressState, setAddressState] = useState({
        addressId: '',
        il: '',
        ilce: '',
        address: '',
        addressTypeId: '',
        addressTypeEnumValue: '',
    });
    const [originalAddressState, setOriginalAddressState] = useState({
        addressId: '',
        il: '',
        ilce: '',
        address: '',
        addressTypeId: '',
        addressTypeEnumValue: '',
    });
    const [addressEditModalShow, setAddressEditModalShow] = useState(false);
    const [districts, setDistricts] = useState([]);
    const [isLoadingAddress, setIsLoadingAddress] = useState(false);

    useEffect(() => {
        setModalShow(props.showModal);
    }, [props]);

    const modalHandleClose = () => {
        setCardState({
            cvc: '',
            expiry: '',
            focus: '',
            name: '',
            number: '',
        });
        setValidState({
            cvc: false,
            expiry: false,
            name: false,
            number: false,
            email: false,
            gsm: false
        });
        setCreditCardValidated(false);
        setModalShow(false);
        props?.close();
        setShowInstallments(false);
        //window.location.reload();
    }

    const showInstallmentPanels = () => {
        if(validState.number){
            fetch(getPaymentInstallmentsUrl, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'ApiAuthorization': 'Bearer '.concat(props.cookies.subscriptionToken)
                },
                body: JSON.stringify({"creditCardNumber" : cardState.number, "payAmount" : props.payAmount})
            }).then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    setShowInstallments(false);
                    return res.json().then(err => {
                        console.error("err : ", err)
                        throw new Error(err.message || connectionErrorMessage);
                    });
                }
            }).then((data) => {
                if (!data) {
                    return;
                }
                setInstallmentData(data.installments);
                setShowInstallments(!showInstallments);
            }, (error) => {
                setShowInstallments(false);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                } else {
                    toast.error("Kart İçin Taksit Bilgisi Alınamadı!", {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });

        } else {
            setShowInstallments(false);
            toast.error("Lütfen Kredi Kartı Bilgilerinizi Giriniz!", {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    const secureScreenClose = () => {
        setSecureUrl('');
        setSecureScreenShow(false);
        setCreditCardValidated(false);
        setModalShow(false);
        setShowInstallments(false);
        props?.close();
    }

    const validateCard = () => {
        if (!(validState.cvc && validState.expiry && validState.name && validState.number && validState.gsm && validState.email)) {
            setCreditCardValidated(true);
            return false;
        }
        return true;
    }


    const handleCardNumberChange = (e) => {
        const {value} = e.target;

        if (value) {
            let formattedValue = formatCardNumber(value);
            if (value.length <= 19) {
                setCardState({...cardState, focus: 'number', 'number': formattedValue});
            }
            if (formattedValue.length >= 19) {
                setValidState({...validState, number: true});
            } else {
                setValidState({...validState, number: false});
            }
        } else {
            setCardState({...cardState, focus: 'number', 'number': value});
            setValidState({...validState, number: false});
        }

    }

    const handleCardCVCChange = (e) => {
        const {value} = e.target;
        if (value) {
            if (value.length < 4) {
                setCardState({...cardState, focus: 'cvc', 'cvc': formatCvc(value)});
            }
        } else {
            setCardState({...cardState, focus: 'cvc', 'cvc': ''});
        }

        if (e.target.value && e.target.value.length >= 3) {
            setValidState({...validState, cvc: true});
        } else {
            setValidState({...validState, cvc: false});
        }
    }

    const handleCardExpiryChange = (e) => {
        if (e.target.value) {
            setCardState({...cardState, focus: 'expiry', expiry: formatExpiry(e)});
        } else {
            setCardState({...cardState, focus: 'expiry', expiry: ''});
        }

        if (e.target.value && e.target.value.length >= 7) {
            setValidState({...validState, expiry: true});
        } else {
            setValidState({...validState, expiry: false});
        }
    }

    const handleEmailChange = (e) => {
        if (e.target.value) {
            setCardState({...cardState, email: e.target.value});
        } else {
            setCardState({...cardState, email: ''});
        }

        if (e.target.value && EMAIL_VALIDATE.test(e.target.value)) {
            setValidState({...validState, email: true});
        } else {
            setValidState({...validState, email: false});
        }
    }

    const handleGsmChange = (e) => {
        if (e.target.value) {
            if (e.target.value.length < 12 && ONLY_NUMBER_REGEX.test(e.target.value)) {
                setCardState({...cardState, gsm: e.target.value});
            }
        } else {
            setCardState({...cardState, gsm: ''});
        }

        if (e.target.value && e.target.value.length >= 11 && ONLY_NUMBER_REGEX.test(e.target.value)) {
            setValidState({...validState, gsm: true});
        } else {
            setValidState({...validState, gsm: false});
        }
    }

    const handleCardNameChange = (e) => {
        const {value} = e.target;
        setCardState({...cardState, focus: 'name', name: value});
        if (value && value.length > 0) {
            setValidState({...validState, name: true});
        } else {
            setValidState({...validState, name: false});
        }
    }

    const checkAdminManagement = (props) => {
        fetch(adminManagementCheckUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(props.cookies.subscriptionToken)
            },
        }).then(res => {
            if (res.ok) {
                setHasAdminManagement(true)
            } else {
                setHasAdminManagement(false)
            }
        })
    }

    const onChangePayPaymentId = (item) => {
        if (item.target.value >= 0) {
            setPayPaymentId(item.target.value);
        }
    };

    const handlePaymentTestResponse = (res, isSuccess) => {
        if (res.type === 'opaqueredirect' || res.status === 0 || res.ok) {
            if (isSuccess) {
                toast.success("Test ödemesi BAŞARILI olarak işaretlendi. (Ödeme ID: " + payPaymentId + ")", {
                    position: toast.POSITION.TOP_CENTER
                });
            } else {
                toast.info("Test ödemesi BAŞARISIZ olarak işaretlendi. (Ödeme ID: " + payPaymentId + ")", {
                    position: toast.POSITION.TOP_CENTER
                });
            }
            secureScreenClose();
        } else {
            toast.error("İşlem gerçekleştirilemedi (HTTP " + res.status + "). Lütfen Ödeme ID'sini kontrol edin.", {
                position: toast.POSITION.TOP_CENTER
            });
            setTestProcessing(false);
        }
    };

    const successPayTest = () => {
        if (!payPaymentId) {
            toast.error("Lütfen Ödeme ID giriniz!", {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }
        if (testProcessing) {
            return;
        }
        setTestProcessing(true);

        fetch(testSuccessPaymentUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                "TURKPOS_RETVAL_Sonuc": 1,
                "TURKPOS_RETVAL_Sonuc_Str": "1 - Başarılı",
                "TURKPOS_RETVAL_GUID": "123e4567-e89b-12d3-a456-426655440000",
                "TURKPOS_RETVAL_Islem_Tarih": new Date(),
                "TURKPOS_RETVAL_Dekont_ID": payPaymentId,
                "TURKPOS_RETVAL_Tahsilat_Tutari": 0,
                "TURKPOS_RETVAL_Odeme_Tutari": 0,
                "TURKPOS_RETVAL_Siparis_ID": payPaymentId,
                "TURKPOS_RETVAL_Islem_ID": payPaymentId,
                "TURKPOS_RETVAL_Ext_Data": {"EkBilgi": "Veri 1","EkBilgi2": "Veri 2"},
                "TURKPOS_RETVAL_Banka_Sonuc_Kod": "00"
            }),
            redirect: 'manual'
        }).then((res) => handlePaymentTestResponse(res, true))
            .catch((error) => {
                debugLog(error);
                toast.error("Bağlantı hatası: işlem gerçekleştirilemedi.", {
                    position: toast.POSITION.TOP_CENTER
                });
                setTestProcessing(false);
            });
    }
    const fetchAddressInfo = useCallback(() => {
        setIsLoadingAddress(true);
        fetch(getAddressByOwnerTenantIdUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(props.cookies.subscriptionToken)
            },
        }).then(res => {
            if (res.ok) {
                return res.json();
            } else {
                throw new Error(errorMessage);
            }
        })
            .then(
                (data) => {
                    if (!data) {
                        return;
                    }
                    setAddressState({
                        addressId: data.addressId || '',
                        il: data.cityDto?.name || '',
                        ilce: data.districtDto?.name || '',
                        address: data.addressText || '',
                        addressTypeId: data.addressTypeId || '',
                        addressTypeEnumValue: data.addressTypeEnumValue || ''
                    });

                    if (data.cityDto?.id) {
                        fetchDistricts(data.cityDto.id);
                    }
                },
                (error) => {
                    debugLog(error);
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            )
            .finally(() => {
                setIsLoadingAddress(false);
            });
    }, [props.cookies.subscriptionToken]);

    useEffect(() => {
        if (modalShow) {
            fetchAddressInfo();
        }
    }, [modalShow, fetchAddressInfo]);

    const fetchCityList = () => {
        fetch(getCityListUrl)
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                setCities(data);
                setAddressEditModalShow(true)

            }, (error) => {
                debugLog(error);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
    }

    const fetchDistricts = (cityId) => {
        fetch(getDistrictsByCityIdUrl + "/"+ cityId)
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then(
                (data) => {
                    if (!data) {
                        return;
                    }
                    setDistricts(data);
                },
                (error) => {
                    debugLog(error);
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            );
    };

    const errorPayTest = () => {
        if (!payPaymentId) {
            toast.error("Lütfen Ödeme ID giriniz!", {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }
        if (testProcessing) {
            return;
        }
        setTestProcessing(true);

        fetch(testErrorPaymentUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                "TURKPOS_RETVAL_Sonuc": 0,
                "TURKPOS_RETVAL_Sonuc_Str": "0 - Başarısız",
                "TURKPOS_RETVAL_GUID": "123e4567-e89b-12d3-a456-426655440000",
                "TURKPOS_RETVAL_Islem_Tarih": new Date(),
                "TURKPOS_RETVAL_Dekont_ID": "123456789",
                "TURKPOS_RETVAL_Tahsilat_Tutari": 0,
                "TURKPOS_RETVAL_Odeme_Tutari": 0,
                "TURKPOS_RETVAL_Siparis_ID": payPaymentId,
                "TURKPOS_RETVAL_Islem_ID": payPaymentId,
                "TURKPOS_RETVAL_Ext_Data": {"EkBilgi": "Veri 1","EkBilgi2": "Veri 2"},
                "TURKPOS_RETVAL_Banka_Sonuc_Kod": "00"
            }),
            redirect: 'manual'
        }).then((res) => handlePaymentTestResponse(res, false))
            .catch((error) => {
                debugLog(error);
                toast.error("Bağlantı hatası: işlem gerçekleştirilemedi.", {
                    position: toast.POSITION.TOP_CENTER
                });
                setTestProcessing(false);
            });
    }


    const pay = () => {
        checkAdminManagement(props);
        const [head, ...tail] = cardState.expiry.split(' / ');
        if (!validateCard()) {
            return;
        }
        let paymentRequestDto = props.request;
        paymentRequestDto = {...paymentRequestDto,
            subscriptionPaymentMethodEnumValue: 'CREDIT_CARD',
            paymentSystemReferenceValue: 'UYAP',
            creditCardOwner: cardState.name,
            creditCardNo: cardState.number,
            creditCardLastUsageMonth: head,
            creditCardLastUsageYear: '20'.concat(tail),
            creditCardCvc: cardState.cvc,
            creditCardOwnerGsm: cardState.gsm,
            billingEmail: cardState.email,
            payAmount: props.payAmount,
            selectedInstallmentId: selectedInstallmentId,

        }
        setPaymentProcessing(true);
        try {
            fetch(payUrl, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'ApiAuthorization': 'Bearer '.concat(props.cookies.subscriptionToken)
                },
                body: JSON.stringify(paymentRequestDto)
            }).then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    return res.json().then(err => {
                        console.error("err : ", err)
                        throw new Error(err.message || connectionErrorMessage);
                    });
                }
            })
                .then((data) => {
                    if (data.sonuc > 0) {
                        setCardState({
                            cvc: '',
                            expiry: '',
                            focus: '',
                            name: '',
                            number: ''
                        });
                        setSecureUrl(data.ucdurl);
                        setModalShow(false);
                        setSecureScreenShow(true);
                        setPaymentProcessing(false);
                    } else {
                        toast.error(data.sonucStr, {
                            position: toast.POSITION.TOP_CENTER
                        });
                        setPaymentProcessing(false);
                    }
                }, (error) => {
                    if (error) {
                        toast.error(error.message, {
                            position: toast.POSITION.TOP_CENTER
                        });
                    }
                    setPaymentProcessing(false);
                });
            window.scrollTo(0, 0);

        } catch (e) {
            toast.error(errorMessage);
        }
    }

    const handleAddressChange = (e) => {
        const { name, value } = e.target;
        setAddressState(prev => ({
            ...prev,
            [name]: value
        }));

        if (name === 'il') {
            const selectedCity = cities.find(city => city.name === value);
            if (selectedCity) {
                fetchDistricts(selectedCity.id);
                setAddressState(prev => ({
                    ...prev,
                    ilce: ''
                }));
            }
        }
    };

    const handleAddressSave = async () => {
        fetch(saveAddressUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(props.cookies.subscriptionToken)
            },
            body: JSON.stringify({
                addressId: addressState.addressId,
                addressTypeId: addressState.addressTypeId,
                addressTypeEnumValue: addressState.addressTypeEnumValue,
                addressText: addressState.address,
                addressFullText: addressState.il && addressState.ilce && addressState.address ?
                    `${addressState.address}, ${addressState.ilce}/${addressState.il}` : '',
                cityDto: {
                    id: cities.find(city => city.name === addressState.il)?.id
                },
                districtDto: {
                    id: districts.find(district => district.name === addressState.ilce)?.id
                }
            })
        }).then(res => {
            if (res.ok) {
                toast.success('Adres başarıyla kaydedildi');
                setAddressEditModalShow(false);
                fetchAddressInfo();
            } else {
                return res.json().then(err => {
                    console.error("err : ", err)
                    toast.error(err.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                });
            }
        });
    }
    const handleAddressEditClick = (e) => {
        e.preventDefault();
        setOriginalAddressState({...addressState});
        setAddressEditModalShow(true);
        fetchCityList();
    };
    const handleAddressEditModalClose = () => {
        setAddressState({...originalAddressState});
        setAddressEditModalShow(false);
    };



    return (<>
        <Modal centered size='lg' show={modalShow} onHide={modalHandleClose} backdrop="static">
            <Form>
                <Modal.Header closeButton>
                    <Modal.Title>{props?.addFileCount ? "Ek Dosya Ödeme" : props.type + "Abonelik Ödeme"} </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{padding:"10px 0 0 0"}}>
                    <Row>
                        <Col className='pb-2' lg={6}>
                            <Cards
                                cvc={cardState.cvc}
                                expiry={cardState.expiry}
                                focused={cardState.focus}
                                name={cardState.name}
                                number={cardState.number}
                                placeholders={{
                                    name: 'Ad Soyad'
                                }}
                            />
                            <SinglePaymentTable payAmount={props.payAmount}
                                                selectedInstallmentId={selectedInstallmentId}
                                                setSelectedInstallmentId={setSelectedInstallmentId}/>
                            <div className="p-0 justify-content-center">
                                <Nav.Link href="#" style={{textAlign:"center"}} onClick={showInstallmentPanels}>
                                    Taksit Seçenekleri İçin Tıklayınız
                                </Nav.Link>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <Form.Row>
                                <Form.Group as={Col}>
                                    <Form.Control
                                        type='text'
                                        value={cardState.name}
                                        onChange={handleCardNameChange}
                                        placeholder='Kart Üzerindeki İsim'
                                        isValid={validState.name}
                                        isInvalid={!validState.name && creditCardValidated}
                                    />
                                    <Form.Control.Feedback type="invalid">{}</Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col}>
                                    <Form.Control
                                        type='text'
                                        value={cardState.number}
                                        onChange={handleCardNumberChange}
                                        placeholder='Kart Numarası'
                                        required
                                        isValid={validState.number}
                                        isInvalid={!validState.number && creditCardValidated}
                                    />
                                    <Form.Control.Feedback type="invalid">{}</Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} lg={8}>
                                    <Form.Control
                                        type='text'
                                        value={cardState.expiry}
                                        onChange={handleCardExpiryChange}
                                        placeholder='Son Kullanma Tarihi'
                                        required
                                        isValid={validState.expiry}
                                        isInvalid={!validState.expiry && creditCardValidated}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} lg={4}>
                                    <Form.Control
                                        type='text'
                                        value={cardState.cvc}
                                        onChange={handleCardCVCChange}
                                        placeholder='CVC'
                                        required
                                        isValid={validState.cvc}
                                        isInvalid={!validState.cvc && creditCardValidated}
                                    />
                                    <Form.Control.Feedback type="invalid">{}</Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} lg={12}>
                                    <Form.Control
                                        type='text'
                                        value={cardState.gsm}
                                        onChange={handleGsmChange}
                                        placeholder='Cep Telefonu Numarası'
                                        required
                                        isValid={validState.gsm}
                                        isInvalid={!validState.gsm && creditCardValidated}
                                    />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} lg={12}>
                                    <Form.Control
                                        type="email"
                                        value={cardState.email}
                                        onChange={handleEmailChange}
                                        placeholder='Dekontun İletileceği Mail Adresi'
                                        required
                                        isValid={validState.email}
                                        isInvalid={!validState.email && creditCardValidated}
                                    />
                                </Form.Group>
                            </Form.Row>

                            <div className="row pb-4">
                                <div className="col-12">
                                    <div style={{position: 'relative'}}>
                                        <TextField
                                            label="Fatura Adresi"
                                            variant="outlined"
                                            multiline
                                            rows={3}
                                            value={addressState.il && addressState.ilce && addressState.address ?
                                                `${addressState.address}, ${addressState.ilce}/${addressState.il}` : ''}
                                            fullWidth
                                            InputProps={{
                                                readOnly: true,
                                                disabled: isLoadingAddress
                                            }}
                                            sx={{
                                                backgroundColor: isLoadingAddress ? '#f5f5f5' : 'white',
                                                '& .MuiInputLabel-root': {
                                                    color: '#1976d2'
                                                },
                                                '& .MuiOutlinedInput-input': {
                                                    fontSize: '12px'
                                                }
                                            }}
                                        />
                                        <Link
                                            component="button"
                                            onClick={handleAddressEditClick}
                                            sx={{
                                                fontSize: '13px',
                                                color: 'darkblue',
                                                textDecoration: 'underline',
                                                cursor: 'pointer',
                                                position: 'absolute',
                                                bottom: '-5px',
                                                right: '14px',
                                                zIndex: 1,
                                                backgroundColor: 'white',
                                                paddingLeft: '4px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '4px',
                                                '&:hover': {
                                                    color: '#333',
                                                    '& .MuiSvgIcon-root': {
                                                        color: '#333'
                                                    }
                                                }
                                            }}
                                        >
                                            <EditIcon sx={{fontSize: 14, color: 'darkblue'}}/>
                                            Düzenle
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>


                    <Row>
                        {showInstallments && <InstallmentsTable data={installmentData}
                                                                selectedInstallmentId={selectedInstallmentId}
                                                                setSelectedInstallmentId={setSelectedInstallmentId}/>}
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={pay} disabled={paymentProcessing}>
                        {paymentProcessing ? (<Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />) : " Öde"}
                    </Button>
                    <Button variant="secondary" onClick={modalHandleClose}>
                        Kapat
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>

        <Modal centered show={addressEditModalShow} onHide={handleAddressEditModalClose}>
            <Modal.Header closeButton>
                <Modal.Title style={{color: 'darkblue'}}>Adres Bilgileri Düzenle</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row>
                        <Col lg={6}>
                            <Form.Group className="mb-3">
                                <select
                                    className="form-control"
                                    name="il"
                                    value={addressState.il}
                                    onChange={handleAddressChange}
                                    required
                                >
                                    <option value="">İl Seçiniz</option>
                                    {cities.map((city) => (
                                        <option key={city.id} value={city.name}>
                                            {city.name}
                                        </option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Lütfen il seçiniz
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col lg={6}>

                            <Form.Group className="mb-3">
                                <select
                                    className="form-control"
                                    name="ilce"
                                    value={addressState.ilce}
                                    onChange={handleAddressChange}
                                    required
                                >
                                    <option value="">İlçe Seçiniz</option>
                                    {districts.map((district) => (
                                        <option key={district.id} value={district.name}>
                                            {district.name}
                                        </option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Lütfen ilçe seçiniz
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Form.Group className="mb-3">
                                <Form.Control
                                    as="textarea"
                                    name="address"
                                    value={addressState.address}
                                    onChange={handleAddressChange}
                                    placeholder="Adres"
                                    required
                                    maxLength={250}
                                    rows={3}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" type="button" onClick={handleAddressSave}>
                    Kaydet
                </Button>
                <Button variant="secondary" onClick={handleAddressEditModalClose}>
                    İptal
                </Button>
            </Modal.Footer>
        </Modal>

        <Modal centered size='lg' show={secureScreenShow} onHide={secureScreenClose}>
            <Modal.Header closeButton>
                <Modal.Title>{props?.addFileCount ? "Ek Dosya Ödeme" : "Abonelik Ödeme"}</Modal.Title>
            </Modal.Header>
            <iframe title={props?.addFileCount ? "Ek Dosya Ödeme" : "Abonelik Ödeme"} className="resp-iframe" src={secureUrl}/>
            {hasAdminManagement &&
                <PaymentTestSimulationPanel
                    payPaymentId={payPaymentId}
                    onChangePayPaymentId={onChangePayPaymentId}
                    onSuccessClick={successPayTest}
                    onErrorClick={errorPayTest}
                    testProcessing={testProcessing}
                />
            }
        </Modal>
    </>)
}

export default PaymentModal;